import { all, put, call, takeEvery } from 'redux-saga/effects';
import { showLoading, hideLoading } from '../../actions/Login/action';
import * as constants from '../../utils/constants';
import request from '../../utils/request';
import {
  confirmStartInformationSuccess,
  confirmStartInformationStatusMessage,
  showWarningDialog
} from '../../actions/myload/action';

import { DomainConverter } from '../../utils/common';
import { StartTripModel } from '../../models/home/StartTrip.model';
import {
  shipmentForStartTrip,
  startTripInformationResponse,
  completeTripApiResponse,
  shipmentForStartTripTimestamp,
} from '../../actions/carrierAssign/action';
const APPLICATION_JSON_TEXT = 'application/json';
const startTripModel = new StartTripModel();
export function* completeTripSaga(data: any) {
  try {
    yield put(showLoading());
    const query = DomainConverter.domainToData<any>(data.payload.data);
    const response = yield call(request, [
      'MYLOAD',
      'CARRIER_WITH_EXPERIENCE',
      null,
      '',
      query,
      APPLICATION_JSON_TEXT
    ]);
    yield put(completeTripApiResponse(response && response.data));
    const completeTrip =
      (response && response.data && response.data.completeTrip) || {};

    const errors = response && response.errors;

    if (!errors) {
      yield put(shipmentForStartTrip(completeTrip.shipment));
      yield put(shipmentForStartTripTimestamp(new Date().getTime().toString()));

      if (completeTrip.status === true && !completeTrip.message) {
        yield put(
          confirmStartInformationStatusMessage({
            status: false,
            message:
              `Great, that marks the end of your trip for load ${data.payload.shipmentId}`
          })
        );
      } else if (completeTrip && completeTrip.message) {
        yield put(
          confirmStartInformationStatusMessage({
            status: false,
            message: completeTrip.message
          })
        );
      }
    } else if (errors && errors.length > 0 && errors[0].message) {
      yield put(
        confirmStartInformationStatusMessage({
          status: false,
          message: errors[0].message
        })
      );
    }

    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
  }
}
export function* updateStop(data: any) {
  try {
    yield put(showLoading());
    const queryParams = DomainConverter.domainToData<any>(data.payload.data);
    const fetchResults = yield call(request, [
      'MYLOAD',
      'CARRIER_WITH_EXPERIENCE',
      null,
      '',
      queryParams,
      APPLICATION_JSON_TEXT
    ]);
    const updateStop =
      (fetchResults?.data?.updateStop) ||
      {};
    const errors = fetchResults?.errors;

    if (!errors) {
      startTripModel.stopStatus({status: updateStop.status, message: updateStop.message});
      yield put(shipmentForStartTrip(updateStop.shipment));
      yield put(shipmentForStartTripTimestamp(new Date().getTime().toString()));
      if (updateStop && updateStop.message && updateStop.status === true && updateStop.needUserConcentForTrailerWarning) {
        yield put(showWarningDialog(updateStop.message));
      } else if (updateStop && updateStop.message) {
        yield put(
          confirmStartInformationStatusMessage({
            status: false,
            message: updateStop.message
          })
        );
      }

      if (data.payload.callBack) {
        data.payload.callBack(
          updateStop.shipment,
          updateStop.status,
          updateStop.message
        );
      }
    } else if (errors && errors.length > 0 && errors[0].message) {
      yield put(
        confirmStartInformationStatusMessage({
          status: false,
          message: errors[0].message
        })
      );
    }

    yield put(hideLoading());
  } catch (error) {
    yield put(hideLoading());
  }
}
export function* stratTrip(data: any) {
  try {
    yield put(showLoading());
    const queryParams = DomainConverter.domainToData<any>(data.payload);
    const fetchResults = yield call(request, [
      'MYLOAD',
      'CARRIER_WITH_EXPERIENCE',
      null,
      '',
      queryParams,
      APPLICATION_JSON_TEXT
    ]);
    const startTrip =
      (fetchResults && fetchResults.data && fetchResults.data.startTrip) ||
      {};

    const errors = fetchResults && fetchResults.errors;

    if (!errors) {
      yield put(shipmentForStartTrip(startTrip.shipment));
      yield put(shipmentForStartTripTimestamp(new Date().getTime().toString()));

      if (startTrip && startTrip.message) {
        yield put(
          confirmStartInformationStatusMessage({
            status: false,
            message: startTrip.message
          })
        );
      }

      if (data.callback && startTrip) {
        data.callback(startTrip);
      }
    } else if (errors && errors.length > 0 && errors[0].message) {
      yield put(
        confirmStartInformationStatusMessage({
          status: false,
          message: errors[0].message
        })
      );
    }

    yield put(startTripInformationResponse(fetchResults.data.startTrip));
    yield put(hideLoading());
  } catch (error) {
    yield put(hideLoading());
  }
}
export function* confirmStartSaga(data: any) {
  try {
    yield put(showLoading());
    const queryParams = DomainConverter.domainToData<any>(data.payload.data);
    const fetchResults = yield call(request, [
      'MYLOAD',
      'CARRIER_WITH_EXPERIENCE',
      null,
      '',
      queryParams,
      APPLICATION_JSON_TEXT
    ]);
    const confirmStart =
      (fetchResults &&
        fetchResults.data &&
        fetchResults.data.confirmStart) ||
      {};

    const errors = fetchResults && fetchResults.errors;

    if (!errors) {
      yield put(shipmentForStartTrip(confirmStart.shipment));
      yield put(shipmentForStartTripTimestamp(new Date().getTime().toString()));
      if (confirmStart && confirmStart.message) {
        yield put(
          confirmStartInformationStatusMessage({
            status: false,
            message: confirmStart.message
          })
        );
      }

      if (data.payload.callback) {
        data.payload.callback(confirmStart.shipment);
      }
    } else if (errors && errors.length > 0 && errors[0].message) {
      yield put(
        confirmStartInformationStatusMessage({
          status: false,
          message: errors[0].message
        })
      );
    }
    yield put(confirmStartInformationSuccess(confirmStart.shipment));
    yield put(hideLoading());
  } catch (error) {
    yield put(hideLoading());
  }
}
export function* updateGPSStatusSaga(_data : {type:string,payload:{data:any,callback:any}}) {
  try {
    yield put(showLoading());
    const queryParams = DomainConverter.domainToData<any>(_data?.payload?.data);
    const fetchResults: {
      data: { updateGpsTracking: string };
      errors?: any;
    } = yield call(request, [
      "MYLOAD",
      "CARRIER_WITH_EXPERIENCE",
      null,
      "",
      queryParams,
      APPLICATION_JSON_TEXT
    ]);
    const updateGpsTracking = fetchResults?.data?.updateGpsTracking || null;
    const errors = fetchResults?.errors || null;
    if(_data?.payload?.callback){
      if(!errors ){
        _data?.payload?.callback({
          status : "success",
          message : updateGpsTracking
        })
      } else {
        console.error("Errors : ",errors);
        _data?.payload?.callback({
          status : "error",
          message : errors && errors.length > 0 && errors[0].message
        })
      }
    }
    yield put(hideLoading());
  } catch (error) {
    console.error("Errors : ",error);
    yield put(hideLoading());
  }
}
export default function* rootSaga() {
  yield all([
    takeEvery(constants.CarrierActionTypes.CONFIRM_START_INFORMATION, confirmStartSaga),
    takeEvery(constants.CarrierActionTypes.UPDATE_STOP_INFORMATION, updateStop),
    takeEvery(constants.CarrierActionTypes.START_TRIP, stratTrip),
    takeEvery(constants.CarrierActionTypes.COMPLETE_TRIP_API_REQUEST, completeTripSaga),
    takeEvery(constants.CarrierActionTypes.UPDATE_GPS_STATUS, updateGPSStatusSaga),

  ]);
}
